import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import MotionPathPlugin from "gsap/MotionPathPlugin";

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

export function initTruckAnimation() {
  const truckWrapper = document.querySelector("#truck-wrapper");
  const truckImage = document.querySelector("#truck-image");
  const path = document.querySelector("#ghost-path");
  const triggerElement = document.querySelector(".single-post__main");
  const roadContainer = document.querySelector(".road-container");

  // UPDATED SELECTOR: Targeting the new image wrappers
  const checkpoints = document.querySelectorAll(".checkpoint-item");

  if (!truckWrapper || !truckImage || !path || !checkpoints.length) return;

  // 1. Preload Images (Prevent flickering)
  function preloadImages() {
    const sources = [truckImage.getAttribute("href")];
    checkpoints.forEach((cp) => sources.push(cp.dataset.truckSrc));
    sources.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }
  preloadImages();

  // 2. Build Scroll Logic
  let checkpointData = [];

  function calculateCheckpoints() {
    const containerHeight = roadContainer.offsetHeight;
    const initialUrl = truckImage.getAttribute("href");

    checkpointData = Array.from(checkpoints).map((cp) => {
      // 1. Get the top position of the checkpoint image
      const topPos = cp.offsetTop;

      // 2. Get the height of the image (should be approx 85px)
      const imgHeight = cp.offsetHeight;

      // 3. Calculate the DEAD CENTER of the image
      const centerPos = topPos + imgHeight / 2;

      // 4. VISUAL ADJUSTMENT (Crucial)
      // We subtract about 15-20px so the switch happens
      // just as the truck enters the middle zone, not after it leaves.
      // You can tweak this number (-10 to -30) to taste.
      const triggerY = centerPos - 20;

      // 5. Convert to percentage (0 to 1) for GSAP
      const progressTrigger = triggerY / containerHeight;

      return {
        truckUrl: cp.dataset.truckSrc,
        // Clamp ensures we don't get negative numbers or > 1
        progress: gsap.utils.clamp(0, 0.99, progressTrigger),
      };
    });

    // Add Start State (Empty Truck) at the beginning
    checkpointData.unshift({ truckUrl: initialUrl, progress: 0 });

    // Optional: Sort by progress just in case DOM order is weird (safety net)
    checkpointData.sort((a, b) => a.progress - b.progress);
  }

  // 3. Update Truck Function
  let currentUrl = null;
  function updateTruck(progress) {
    let activeUrl = checkpointData[0].truckUrl;
    for (let i = 0; i < checkpointData.length; i++) {
      if (progress >= checkpointData[i].progress) {
        activeUrl = checkpointData[i].truckUrl;
      }
    }
    if (activeUrl !== currentUrl) {
      currentUrl = activeUrl;
      truckImage.setAttribute("href", currentUrl);
    }
  }

  // 4. Init Animation
  calculateCheckpoints();

  // Center Truck
  gsap.set(truckWrapper, {
    xPercent: -50,
    yPercent: -50,
    transformOrigin: "50% 50%",
  });

  gsap.to(truckWrapper, {
    motionPath: {
      path: path,
      align: path,
      autoRotate: true,
      alignOrigin: [0.5, 0.5],
      start: 0,
      end: 1,
    },
    ease: "none",
    scrollTrigger: {
      trigger: triggerElement,
      start: "top top",
      end: "bottom bottom",
      scrub: 0.5,
      invalidateOnRefresh: true,
      onRefresh: calculateCheckpoints,
      onUpdate: (self) => updateTruck(self.progress),
    },
  });
}
